/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// material
import {
  Stack,
  Typography,
  Box,
  LinearProgress,
  FormControl,
  Grid,
  alpha,
  Menu,
  styled,
  useMediaQuery,
  InputLabel,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Drawer,
} from '@mui/material';
// components
import { SketchPicker } from 'react-color';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';
import { db } from '../../../firebase.config';
import CustomButton from '../../../components/CustomButton';
import { useSnackbar } from '../../../context/snackbarContext';
import LucideIcon from '../../../components/LucideIcon';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 7,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

export default function WidgetCustom() {
  const { eventID } = useParams();
  const showSnackbar = useSnackbar()
  const navigate = useNavigate()
  // loading
  const [loading, setLoading] = React.useState(false);

  // for change value of globla quota
  const [bgColor, setBgColor] = useState('#ffffff');
  const [textColor, setTextColor] = useState('#141414');
  const [primaryColor, setPrimaryColor] = useState('#5E17EB');
  const [secondaryColor, setSecondaryColor] = useState('#f2f2f2');
  const [shapeBtPay, setShapeBtPay] = useState('circle');
  const [customIndex, setCustom] = useState(0);
  const [color, setColor] = useState({ bgColor: "", primaryColor: "#5E17EB", secondaryColor: "" });
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleClick = (event) => {
    console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
    if (event.target.id === 'bt-fdColor') {
      setCustom(1)
    } else if (event.target.id === 'bt-primaire') {
      setCustom(2)
    } else if (event.target.id === 'bt-secondaire') {
      setCustom(3)
    }
    else if (event.target.id === 'bt-text') {
      setCustom(4)
    }
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
  };

  const handleBackgroundColorChange = (c) => {
    setBgColor(c.hex);
    setColor({ bgColor: c.hex, primaryColor, secondaryColor, textColor })
  };

  const handlePrimaryColorChange = (c) => {
    setPrimaryColor(c.hex);
    setColor({ bgColor, primaryColor: c.hex, secondaryColor, textColor })
  };

  const handleSecondaryColorChange = (c) => {
    setSecondaryColor(c.hex);
    setColor({ bgColor, primaryColor, secondaryColor: c.hex, textColor })

  };

  const handleTextColorChange = (c) => {
    setTextColor(c.hex);
    setColor({ bgColor, primaryColor, secondaryColor, textColor: c.hex })

  };

  const [url, setUrl] = useState('');

  React.useEffect(() => {
    const params = new URLSearchParams({
      dev: "true",
      bg: bgColor.replace('#', ''),
      primary: primaryColor.replace('#', ''),
      secondary: secondaryColor.replace('#', ''),
      text: textColor.replace('#', ''),
      shapeBtPay: 'circle'
    });

    const fullUrl = `http://localhost:3001/fr/event_embed/${eventID}?${params.toString()}`;
    const fullUrlProd = `https://choptonticket.com/fr/event_embed/${eventID}?${params.toString()}`;
    console.log(fullUrlProd)
    setUrl(fullUrl);
  }, [bgColor, primaryColor, secondaryColor, textColor, eventID, shapeBtPay]);



  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true)
        const docRef0 = doc(db, `evenement/${eventID}/widget`, eventID);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          //
          if (docSnap.data().color !== null) {
            console.log(docSnap.data().custom)
            setBgColor(`#${docSnap.data().color.bgColor}`)
            setPrimaryColor(`#${docSnap.data().color.primaryColor}`)
            setSecondaryColor(`#${docSnap.data().color.secondaryColor}`)
            setTextColor(`#${docSnap.data().color.textColor}`)
            setShapeBtPay(docSnap.data().shape)
          }
        }
      } catch (error) {
        console.log('error');
      }
      setLoading(false)
    })();
  }, [eventID]);

  // save population
  const saveCustom = async () => {
    setLoading(true)
    try {
      const statRef = doc(db, `evenement/${eventID}/widget`, `${eventID}`);
      await setDoc(statRef, {
        color: { bgColor: bgColor.replace('#', ''), primaryColor: primaryColor.replace('#', ''), secondaryColor: secondaryColor.replace('#', ''), textColor: textColor.replace('#', ''), },
        shape: shapeBtPay
      });
      showSnackbar('modifications publié avec succès', false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  };
  const isMobile = useMediaQuery('(max-width:600px)');


  return (
    <Page title="Editeur" >
      <Box sx={{
        height: '60px',
        paddingX: { xs: 1, sm: 2 }, position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: 'background.paper',
        borderBottom: '2px solid #f2f2f2'
      }}>
        <Stack direction={'row'} alignItems={'center'} sx={{ height: '100%', width: '100%' }} justifyContent={'space-between'}>
          <Stack direction={'row'} alignItems={'center'} spacing={1}>
            <CustomButton loading={loading} buttonText={isMobile ? null : 'Retour'} type={'back'} onClick={() => navigate(`/${eventID}/dashboard/site_personnel`, { replace: true })} />
            {
              isMobile && <CustomButton loading={loading} onClick={toggleDrawer(true)} startIcon={<LucideIcon name='Settings' />} buttonText={isMobile ? null : 'Publier les modifications'} type={'primaire'} />
            }
            
          </Stack>

          <CustomButton loading={loading} onClick={saveCustom} startIcon={isMobile ? <LucideIcon name='Save' /> : null} buttonText={isMobile ? null : 'Publier les modifications'} type={'primaire'} />
        </Stack>

      </Box>
      <Box sx={{ height: 'calc(100vh - 60px)' }}>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <Accordion>
              <AccordionSummary
                expandIcon={<Iconify icon={'mingcute:down-line'} />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                  <Iconify icon={'gis:color'} />
                  <Typography variant='subtitle1'>Couleur</Typography>
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={2} padding={1}>
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Fond
                    </Typography>
                    <Box
                      id='bt-fdColor'
                      onClick={handleClick}
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${bgColor}`,
                      }}
                    />
                  </Stack>
                  <Divider />
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Bouton
                    </Typography>
                    <Box
                      id='bt-primaire'
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${primaryColor}`,
                      }}
                      onClick={handleClick}
                    />
                  </Stack>
                  <Divider />
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Couleur secondaire
                    </Typography>
                    <Box
                      id='bt-secondaire'
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${secondaryColor}`,
                      }}
                      onClick={handleClick}
                    />
                  </Stack>
                  <Divider />
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Texte
                    </Typography>
                    <Box
                      id='bt-text'
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${textColor}`,
                      }}
                      onClick={handleClick}
                    />
                  </Stack>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      'aria-labelledby': 'demo-customized-button',
                    }}
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleCloseMenu}
                  >
                    <SketchPicker
                      color={
                        customIndex === 1 ? bgColor : customIndex === 2 ? primaryColor : customIndex === 3 ? secondaryColor : textColor
                      }
                      onChange={
                        customIndex === 1 ? handleBackgroundColorChange : customIndex === 2 ? handlePrimaryColorChange : customIndex === 3 ? handleSecondaryColorChange : handleTextColorChange
                      }
                    />
                  </StyledMenu>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<Iconify icon={'mingcute:down-line'} />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography variant='subtitle1'>Button d'action</Typography>
              </AccordionSummary>
              <AccordionDetails>

                {/* Forme des boutons */}
                <FormControl fullWidth sx={{ my: 2 }}>
                  <InputLabel>Forme du bouton</InputLabel>
                  <Select
                    value={shapeBtPay}
                    onChange={(e) => setShapeBtPay(e.target.value)}
                  >
                    <MenuItem value="circle">Arrondi</MenuItem>
                    <MenuItem value="square">Carré</MenuItem>
                  </Select>
                </FormControl>
              </AccordionDetails>
            </Accordion>
      </Drawer>
        {loading && <LinearProgress />}
        <Grid container columnSpacing={1} sx={{ height: '100%' }}>
          {/* Partie Personnalisation */}
          {
            !isMobile && <Grid item xs={12} md={4} sx={{ height: '100%', overflowY: 'auto' }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<Iconify icon={'mingcute:down-line'} />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                  <Iconify icon={'gis:color'} />
                  <Typography variant='subtitle1'>Couleur</Typography>
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={2} padding={1}>
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Fond
                    </Typography>
                    <Box
                      id='bt-fdColor'
                      onClick={handleClick}
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${bgColor}`,
                      }}
                    />
                  </Stack>
                  <Divider />
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Bouton
                    </Typography>
                    <Box
                      id='bt-primaire'
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${primaryColor}`,
                      }}
                      onClick={handleClick}
                    />
                  </Stack>
                  <Divider />
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Couleur secondaire
                    </Typography>
                    <Box
                      id='bt-secondaire'
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${secondaryColor}`,
                      }}
                      onClick={handleClick}
                    />
                  </Stack>
                  <Divider />
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography textAlign="Start" variant="body2">
                      Texte
                    </Typography>
                    <Box
                      id='bt-text'
                      sx={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '7px',
                        border: '2px solid gainsboro',
                        cursor: 'pointer',
                        bgcolor: `${textColor}`,
                      }}
                      onClick={handleClick}
                    />
                  </Stack>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      'aria-labelledby': 'demo-customized-button',
                    }}
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleCloseMenu}
                  >
                    <SketchPicker
                      color={
                        customIndex === 1 ? bgColor : customIndex === 2 ? primaryColor : customIndex === 3 ? secondaryColor : textColor
                      }
                      onChange={
                        customIndex === 1 ? handleBackgroundColorChange : customIndex === 2 ? handlePrimaryColorChange : customIndex === 3 ? handleSecondaryColorChange : handleTextColorChange
                      }
                    />
                  </StyledMenu>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<Iconify icon={'mingcute:down-line'} />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography variant='subtitle1'>Button d'action</Typography>
              </AccordionSummary>
              <AccordionDetails>

                {/* Forme des boutons */}
                <FormControl fullWidth sx={{ my: 2 }}>
                  <InputLabel>Forme du bouton</InputLabel>
                  <Select
                    value={shapeBtPay}
                    onChange={(e) => setShapeBtPay(e.target.value)}
                  >
                    <MenuItem value="circle">Arrondi</MenuItem>
                    <MenuItem value="square">Carré</MenuItem>
                  </Select>
                </FormControl>
              </AccordionDetails>
            </Accordion>
          </Grid>
          }

          {/* Partie Aperçu */}
          <Grid item xs={12} md={8} sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #f2f2f2', bgcolor: '#f2f2f2' }}>
            <iframe width="600px" height="700px" src={url} title="wiget" style={{ border: '1px solid gainsboro', borderRadius: '10px' }} />
          </Grid>

        </Grid>

      </Box>

    </Page>
  );
}
